import React, { useLayoutEffect, useRef, useState } from 'react'
import type { PopperChildrenProps, ReferenceChildrenProps } from 'react-popper'
import { Manager, Popper, Reference } from 'react-popper'
import * as S from './OrderSummaryTooltip.styled'
import type { Props } from './types'

export const OrderSummaryTooltip = ({ content, children }: Props) => {
  const [isVisible, setIsVisible] = useState(false)
  const positionUpdateRef = useRef<Function | null>(null)

  useLayoutEffect(() => {
    if (positionUpdateRef.current) {
      positionUpdateRef.current()
    }
  }, [content])

  const showTip = () => {
    setIsVisible(true)
  }

  const hideTip = () => {
    setIsVisible(false)
  }

  const renderReferenceChildren = ({ ref }: ReferenceChildrenProps) => {
    return <div ref={ref}>{children}</div>
  }

  const renderPopperChildren = ({
    ref,
    style,
    placement: dataPlacement,
    update,
  }: PopperChildrenProps) => {
    positionUpdateRef.current = update

    return (
      <div
        ref={ref}
        data-placement={dataPlacement}
        style={{ ...style, paddingTop: 4, paddingBottom: 4, zIndex: 1 }}
      >
        <S.Box>{content}</S.Box>
      </div>
    )
  }

  return (
    <Manager>
      <S.Container
        onMouseEnter={showTip}
        onTouchStart={showTip}
        onMouseLeave={hideTip}
        onTouchEnd={hideTip}
        data-testid="OrderSummaryTooltip"
      >
        <Reference>{renderReferenceChildren}</Reference>
        {isVisible && (
          <Popper
            placement="bottom-start"
            modifiers={[
              { name: 'preventOverflow', enabled: false },
              { name: 'hide', enabled: false },
            ]}
          >
            {renderPopperChildren}
          </Popper>
        )}
      </S.Container>
    </Manager>
  )
}
